const inicialState = {
};

export default function (state = inicialState, action) {

  switch (action.type) {

    case 'TABLE_DATA':
      const newState = { ...state };
      newState[action.result.id] = action.result.params;
      return newState;

    default:
      return state;

  }

}



// WEBPACK FOOTER //
// ./src/redux/reducers/tableDataReducer.js